/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SyncAuthSupportVnf$Params {

/**
 * How the auth support slots are written on the PLCs:
 * * AUTOMATIC: Only the updated auth supports are written
 * * FULL: The serial ID and all the auth supports are written. The free slots are reseted.
 * * SERIAL_ID: Only the main serial ID is written
 * * REGISTERED_SLOTS: Only the slots with valid auth support are written
 */
  syncType?: 'AUTOMATIC' | 'FULL' | 'SERIAL_ID' | 'REGISTERED_SLOTS';

/**
 * If defined synchronize the auth supports only for this opcua connection uid. Otherwise syncrhonize for all connections
 */
  opcuaConnectionSyncUid?: string;
}

export function syncAuthSupportVnf(http: HttpClient, rootUrl: string, params?: SyncAuthSupportVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, syncAuthSupportVnf.PATH, 'post');
  if (params) {
    rb.query('syncType', params.syncType, {});
    rb.query('opcuaConnectionSyncUid', params.opcuaConnectionSyncUid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

syncAuthSupportVnf.PATH = '/custom/auth-supports/sync';
